import type { Directive } from "vue";
import clipboard from "./clipboard/clipboard";
import waves from "./waves/waves";
import { usePermissionStore } from "@/stores/permission";

// Permission-based directives
function createRoleDirective(role: string, inverse: boolean = false): Directive {
  return {
    mounted(el: HTMLElement) {
      const permissionStore = usePermissionStore();
      const roles = permissionStore.roles;
      const hasRole = roles.includes(role);

      if (inverse ? hasRole : !hasRole) {
        el.parentNode?.removeChild(el);
      }
    },
  };
}

// Export individual directives
export const Clipboard = clipboard;
export const Waves = waves;

// Role-based directives
export const ifIsUser = createRoleDirective("user");
export const ifIsContact = createRoleDirective("contact");
export const ifIsAdmin = createRoleDirective("admin");
export const ifIsManager = createRoleDirective("manager");
export const ifIsSpaceAdmin = createRoleDirective("space_admin");
export const ifIsNotUser = createRoleDirective("user", true);
export const ifIsNotContact = createRoleDirective("contact", true);
export const ifIsNotManager = createRoleDirective("manager", true);

// Feature flag directives
import { useAccountStore } from "@/stores/account";
import FeatureFlags from "@/enum/FeatureFlags";

function createFeatureFlagDirective(flag: string): Directive {
  return {
    async mounted(el: HTMLElement) {
      try {
        const accountStore = useAccountStore();
        const account = await accountStore.getCurrentAccount();
        const flags = account.data.cff || [];

        if (!flags.includes(flag)) {
          el.parentNode?.removeChild(el);
        }
      } catch {
        el.parentNode?.removeChild(el);
      }
    },
  };
}

export const hasContactsApp = createFeatureFlagDirective(FeatureFlags.CONTACTS_APP);
export const hasTasksApp = createFeatureFlagDirective(FeatureFlags.TASKS_APP);
export const hasProtocolsApp = createFeatureFlagDirective(FeatureFlags.PROTOCOLS_APP);
export const hasProtocolsSignatureApp = createFeatureFlagDirective(FeatureFlags.PROTOCOLS_SIGNATURE);
export const hasMailApp = createFeatureFlagDirective(FeatureFlags.MAIL_APP);
